import { BahfEvents } from '../types/bahf-event.types';
import { OiamEvents } from '@oiambk/oiam-oauth-types';

export class OiamAuthService {
  static sendLogin() {
    //emit own event when user clicked on login button
    window.self.dispatchEvent(new CustomEvent(BahfEvents.LOGINCLICKED));
  }
  static sendLogout() {
    window.self.dispatchEvent(new CustomEvent(OiamEvents.DOLOGOUT));
  }

  static askForToken() {
    // active ask for access token
    window.self.dispatchEvent(new CustomEvent(OiamEvents.SENDTOKEN));
  }

  static handleError(e: CustomEvent) {
    console.error(e);
  }

}
